var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'stream-item-header' + _vm.positionClasses},[_vm._v(_vm._s(_vm._f("humanDayTime")(_vm.createdAt))),(_vm.createdBy)?_c('span',[_vm._v(" - "+_vm._s(_vm.createdBy.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }